<template>
	<div
		ref="contact"
		class="modal fade"
		tabindex="-1"
		data-keyboard="false"
		data-backdrop="static"
	>
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Contate-nos</h5>
					<button
						type="button"
						class="close"
						data-dismiss="modal"
						aria-label="Close"
						:disabled="sending"
					>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<form ref="form">
					<div class="modal-body">
						<div class="input-group mb-3">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<i class="fa fa-user"></i>
								</span>
							</div>
							<input
								class="form-control"
								type="text"
								name="name"
								placeholder="Nome"
								maxlength="50"
								required
								v-model="data.name"
							>
						</div>
						<div class="input-group mb-3">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<i class="fa fa-envelope"></i>
								</span>
							</div>
							<input
								class="form-control"
								type="email"
								name="email"
								placeholder="E-mail"
								maxlength="50"
								required
								v-model="data.email"
							>
						</div>
						<div class="input-group mb-3">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<i class="fa fa-phone"></i>
								</span>
							</div>
							<input
								class="form-control"
								type="phone"
								name="phone"
								placeholder="Telefone"
								minlength="14"
								maxlength="15"
								v-mask="'(##) #####-####'"
								v-model="data.phone"
							>
						</div>
						<div class="form-group">
							<textarea
								class="form-control"
								name="message"
								placeholder="Digite sua mensagem"
								maxlength="300"
								required
								v-model="data.message"
							></textarea>
						</div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							data-dismiss="modal"
							:disabled="sending"
						>
							Cancelar
						</button>
						<button
							@click="send"
							type="button"
							class="btn btn-primary"
							:disabled="sending"
						>
							<span
								v-if="sending"
								class="spinner-border spinner-border-sm loading"
								aria-hidden="true"
							></span>
							<span v-if="!sending" class="text">Enviar</span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		data() {
			return {
				modal: null,
				form: null,
				sending: false,
				data: {
					name: '',
					email: '',
					phone: '',
					message: ''
				},
			};
		},
		mounted() {
			this.modal = $(this.$refs.contact);
			this.form = $(this.$refs.form);
		},
		methods: {
			open() {
				this.modal.modal('show');
			},
			send() {
				this.sending = true;

				let validate = this.validateForm(this.form[0]);

				if (validate != '') {
					Flash('error', validate);
					this.sending = false;
				} else {
					axios.post('/send_contact', this.data)
						.then(res => {
							Swal.fire({
								type: 'success',
								title: 'Enviado',
								text: 'Mensagem enviada com sucesso!'
							});

							this.sending = false;
							this.form.trigger('reset');
							this.modal.modal('hide');
						})
						.catch(err => {
							Flash('error', 'Erro ao enviar mensagem!');
							this.sending = false;
						});
				}
			}
		}
    }
</script>
